export const upperFirst = <T extends string>(s: T): Capitalize<T> => {
  return ((s[0] ?? '').toUpperCase() + s.slice(1)) as Capitalize<T>
}

export const lowerFirst = <T extends string>(s: T): Uncapitalize<T> => {
  return ((s[0] ?? '').toLowerCase() + s.slice(1)) as Uncapitalize<T>
}
